<div class="row">
  <div class="col-6">
    <app-button [title]="'Add' | translate" (click)="addChild()"></app-button>
  </div>
  <div class="col-6">
  <app-button [title]="'Finish' | translate" (click)="finishRegistration()"></app-button>
</div>
</div>
